/* Lite YouTube facade — global delegated click handler.
 * Pairs with snippets/lite-youtube.liquid. Swaps the facade <button> for the real
 * <iframe> only when the user clicks. Idempotent: safe to load multiple times.
 */
(() => {
  if (window.__liteYtBound) return;
  window.__liteYtBound = true;

  function activate(facade) {
    const id = facade.dataset.ytId;
    if (!id) return;
    const autoplay = facade.dataset.ytAutoplay !== 'false';
    const params = new URLSearchParams({
      rel: '0',
      modestbranding: '1',
      playsinline: '1',
    });
    if (autoplay) {
      params.set('autoplay', '1');
    }
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?' + params.toString();
    iframe.title = facade.getAttribute('aria-label') || 'YouTube video player';
    iframe.frameBorder = '0';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.loading = 'lazy';
    // Marker so any "auto-neutralize-YouTube-iframe" observers (we have one in
    // product-template.liquid for EasyVideo's eager injections) leave us alone.
    iframe.setAttribute('data-lite-yt-activated', '1');

    // Match the facade's positioning context so the iframe lands in the same box.
    const cs = getComputedStyle(facade);
    iframe.style.border = '0';
    iframe.style.display = 'block';
    if (cs.position === 'absolute' || facade.classList.contains('lite-yt-facade--overlay')) {
      // Overlay mode: fill the parent slide using absolute positioning.
      // z-index must beat the EasyVideo overlay span (99999) AND any inline
      // !important rules set by normalizeVideoSlideIframes (z-index:1) —
      // we set !important so we win regardless.
      iframe.style.setProperty('position', 'absolute', 'important');
      iframe.style.setProperty('inset', '0', 'important');
      iframe.style.setProperty('top', '0', 'important');
      iframe.style.setProperty('left', '0', 'important');
      iframe.style.setProperty('width', '100%', 'important');
      iframe.style.setProperty('height', '100%', 'important');
      iframe.style.setProperty('z-index', '100001', 'important');
    } else {
      // Default block mode: rely on aspect-ratio for height. Avoid `height:100%`
      // because parent containers may have height:auto, in which case 100%
      // resolves to 0 (sound plays, video invisible).
      iframe.style.width = '100%';
      iframe.style.aspectRatio = (cs.aspectRatio && cs.aspectRatio !== 'auto') ? cs.aspectRatio : '16 / 9';
    }
    facade.replaceWith(iframe);
  }

  document.addEventListener('click', (e) => {
    const facade = e.target.closest && e.target.closest('.lite-yt-facade');
    if (!facade || facade.dataset.ytActivated === '1') return;
    facade.dataset.ytActivated = '1';
    e.preventDefault();
    activate(facade);
  }, { passive: false });

  // Optional: warm up the YouTube origin on first hover/focus so the click feels instant.
  let warmed = false;
  function warmConnections() {
    if (warmed) return;
    warmed = true;
    const hosts = [
      'https://www.youtube-nocookie.com',
      'https://www.youtube.com',
      'https://i.ytimg.com',
      'https://s.ytimg.com',
      'https://yt3.ggpht.com',
    ];
    hosts.forEach((href) => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
  }
  document.addEventListener('pointerover', (e) => {
    if (e.target.closest && e.target.closest('.lite-yt-facade')) warmConnections();
  }, { passive: true, once: false });
  document.addEventListener('focusin', (e) => {
    if (e.target.closest && e.target.closest('.lite-yt-facade')) warmConnections();
  }, { passive: true, once: false });
})();
